var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8356 8H15.8505L12.4481 10.8125H14.4332L17.8356 8Z",
    fill: "var(--ion-color-secondary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2661 8H19.2527L15.8503 10.8125H17.8355L21.2661 8Z",
    fill: "var(--ion-color-secondary)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2526 10.8125H22.2581V8.46873C22.2581 8.43257 22.2465 8.40063 22.2395 8.36682L19.2526 10.8125Z",
    fill: "var(--ion-color-secondary)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01758 10.8125H11.031L14.4334 8H12.4483L9.01758 10.8125Z",
    fill: "var(--ion-color-secondary)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74194 22.5312C7.74194 22.7903 7.93216 23 8.16722 23H21.8328C22.0679 23 22.2581 22.7903 22.2581 22.5312V11.75H7.74194V22.5312ZM12.8736 14.0938C12.8736 13.9248 12.9558 13.7692 13.0892 13.6859C13.2225 13.6026 13.3861 13.6048 13.5178 13.6918L17.7705 16.5043C17.8985 16.589 17.9769 16.7414 17.9769 16.9062C17.9769 17.071 17.8984 17.2234 17.7705 17.3081L13.5178 20.1206C13.3861 20.2076 13.2224 20.2098 13.0892 20.1266C12.9558 20.0433 12.8736 19.8877 12.8736 19.7188V14.0938Z",
    fill: "var(--ion-color-primary)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16722 8C7.93216 8 7.74194 8.20966 7.74194 8.46875V10.6955L11.0312 8H8.16722Z",
    fill: "var(--ion-color-secondary)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7241 14.9219V18.8907L16.7252 16.9063L13.7241 14.9219Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStory);
export default __webpack_public_path__ + "static/media/story.0ef11ff4.svg";
export { ForwardRef as ReactComponent };